import * as React from 'react';

import { flatten, unflatten } from 'flat';
import pick from 'object.pick';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

interface Props {
  query?: any;
  option?: any;
  deps?: Array<any>;
}

const useQueryParam = ({ query = {}, option = {}, deps = [] }: Props): void => {
  const [firstLoad, setFirstLoad] = React.useState(true);
  const history = useHistory();

  React.useEffect(() => {
    const newQuery: any = { ...query };
    Object.keys(query).forEach(key => {
      if (key.includes('where') && Array.isArray(query[key])) {
        delete newQuery[key];
      }
    });
    const standardQuery = unflatten(newQuery);
    const { isVisible, whiteList } = option;

    if (isVisible) {
      if (!firstLoad) {
        history.push(
          `?${queryString.stringify(flatten(pick(standardQuery, whiteList)), {
            skipEmptyString: true,
            skipNull: true,
            allowDots: true,
          })}`
        );
      }
      setFirstLoad(false);
    }
  }, deps); //eslint-disable-line
};

export default useQueryParam;
